import TextInfo from "@gcloud-npm/next12.components.text-info";
import cn from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { THEME_COLOR_NAMES } from "../Theme/enums/colors";
import { useTheme } from "../Theme";
import {
  FONT_TYPE,
  PRICE_DECORATION,
  PRICE_OPACITY,
  PRICE_SIZE,
  SEGMENT,
  PRICE_COLOR,
  PRICE_ALIGN,
} from "./enums";
import css from "./styles";
import { parsePrice } from "./utils";

export { FONT_TYPE, PRICE_DECORATION, PRICE_OPACITY, PRICE_SIZE, PRICE_COLOR };

/**
 * @name Price
 * @description atomic component
 * @see {@link https://bit.dev/gerenciatd/unifiedcomponents/price}
 * @param {any} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */
const Price = ({
  className,
  segment = SEGMENT.GP,
  amount,
  unity,
  size = PRICE_SIZE.REGULAR,
  sizeUnity,
  decoration,
  withSpace = true,
  opacity,
  fontType,
  device,
  color = THEME_COLOR_NAMES.ORANGE,
  style,
  align,
  preserveDecimals = false,
}) => {
  const theme = useTheme();
  const styles = css(theme);

  // FIX React Hydration Error
  // @see {@link https://nextjs.org/docs/messages/react-hydration-error}
  const [value, setValue] = useState(() => {
    return parsePrice({
      number: amount,
      preserveDecimals,
    });
  });

  useEffect(() => {
    setValue(
      parsePrice({
        number: amount,
        preserveDecimals,
      })
    );
  }, [amount]);

  return (
    <>
      <span
        className={cn(
          "price",
          segment && `price--segment-${segment}`,
          size && `price_size--${size}`,
          decoration && `price_decoration--${decoration}`,
          opacity && `price_opacity--${opacity}`,
          fontType && `price_${segment}--font-${fontType}`,
          align && `price_align-${align}`,
          color && `price_color-${segment}--${color}`,
          className
        )}
      >
        {withSpace ? `${value} ` : `${value}`}
        <span className={sizeUnity && `price_size--${sizeUnity}`}>{unity}</span>
      </span>

      <style jsx>{styles}</style>
    </>
  );
};

Price.propTypes = {
  className: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  unity: PropTypes.string,
  color: PropTypes.oneOf(Object.values(THEME_COLOR_NAMES)),
  size: PropTypes.oneOf(Object.values(PRICE_SIZE)),
  decoration: PropTypes.oneOf(Object.values(PRICE_DECORATION)),
  withSpace: PropTypes.bool,
  align: PropTypes.oneOf(Object.values(PRICE_ALIGN)),
  opacity: PropTypes.oneOf(Object.values(PRICE_OPACITY)),
  fontType: PropTypes.oneOf(Object.values(FONT_TYPE)),
  segment: PropTypes.oneOf(Object.values(SEGMENT)),
};

Price.defaultProps = {
  className: "",
  unity: "",
  size: PRICE_SIZE.REGULAR,
  color: PRICE_COLOR.DARK_BLUE,
  withSpace: true,
  segment: SEGMENT.GP,
  decoration: PRICE_DECORATION.NONE,
  opacity: PRICE_OPACITY.OP_1,
  fontType: FONT_TYPE.REGULAR,
  align: PRICE_ALIGN.LEFT,
};

export default Price;
